module.exports = __webpack_public_path__ + "img/terminal-1.a6365a48.webp";